import { render, staticRenderFns } from "./Acoes.vue?vue&type=template&id=2a5e0a0a&scoped=true&"
import script from "./Acoes.vue?vue&type=script&lang=js&"
export * from "./Acoes.vue?vue&type=script&lang=js&"
import style0 from "./Acoes.vue?vue&type=style&index=0&id=2a5e0a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e0a0a",
  null
  
)

export default component.exports